import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import "react";
import { cleanProps, cn } from "../../utils/index.js";
import { A } from "../A/index.js";
import { Button } from "../Button/index.js";
import { P } from "../Text/index.js";
import { stickyActionBar } from "./StickyActionBar.variants.js";
function StickyActionBar({ children, headerContent, actionText, helperText, isLink = false, url, type = 'primary', onClick, actionDisplay = 'lg', floating = false, shadow = true, secondaryActionText, secondaryOnClick, tertiaryActionText, tertiaryOnClick, barType, className, slots = {}, ...props }) {
    const hasSecondaryAction = Boolean(secondaryActionText);
    const hasTertiaryAction = Boolean(tertiaryActionText);
    let actionCount = 'one';
    if (hasSecondaryAction && hasTertiaryAction) actionCount = 'three';
    else if (hasSecondaryAction || hasTertiaryAction) actionCount = 'two';
    const { root, contentWrapper, mainContainer, textContainer, actionContainer, headerContainer, helperTextSlot, primaryActionContainer, secondaryActionContainer, tertiaryActionContainer } = stickyActionBar({
        barType,
        actionDisplay,
        floating,
        actionCount,
        type
    });
    const buttonSize = 'lg' === actionDisplay ? 'lg' : 'md';
    const isFullWidthButton = 'mdRight' !== actionDisplay;
    const domProps = cleanProps(props, Object.keys(stickyActionBar.variants));
    const rootClasses = root({
        className: cn(shadow ? void 0 : 'shadow-none', className, slots.root)
    });
    const renderPrimaryAction = ()=>isLink ? /*#__PURE__*/ jsx(A, {
            href: url,
            type: type ?? 'primaryShop',
            fullWidth: isFullWidthButton,
            size: buttonSize,
            shadow: true,
            children: actionText
        }) : /*#__PURE__*/ jsx(Button, {
            type: type ?? 'primary',
            fullWidth: isFullWidthButton,
            size: buttonSize,
            shadow: true,
            onClick: onClick,
            children: actionText
        });
    const renderSecondaryAction = ()=>{
        if (!hasSecondaryAction) return null;
        return /*#__PURE__*/ jsx(Button, {
            type: "secondary",
            size: buttonSize,
            fullWidth: isFullWidthButton,
            onClick: secondaryOnClick,
            children: secondaryActionText
        });
    };
    const renderTertiaryAction = ()=>{
        if (!hasTertiaryAction) return null;
        return /*#__PURE__*/ jsx(Button, {
            type: "tertiary",
            size: buttonSize,
            fullWidth: isFullWidthButton,
            onClick: tertiaryOnClick,
            children: tertiaryActionText
        });
    };
    const hasMultipleActions = hasSecondaryAction || hasTertiaryAction;
    return /*#__PURE__*/ jsxs("div", {
        ...domProps,
        className: rootClasses,
        children: [
            headerContent && /*#__PURE__*/ jsx("div", {
                className: headerContainer({
                    className: slots.headerContainer
                }),
                children: headerContent
            }),
            /*#__PURE__*/ jsxs("div", {
                className: contentWrapper({
                    className: slots.contentWrapper
                }),
                children: [
                    /*#__PURE__*/ jsxs("div", {
                        className: mainContainer({
                            className: slots.mainContainer
                        }),
                        children: [
                            children && 'bookBar' === barType && /*#__PURE__*/ jsx("div", {
                                className: textContainer({
                                    className: slots.textContainer
                                }),
                                children: children
                            }),
                            /*#__PURE__*/ jsx("div", {
                                className: actionContainer({
                                    className: slots.actionContainer
                                }),
                                children: hasMultipleActions ? /*#__PURE__*/ jsxs(Fragment, {
                                    children: [
                                        hasTertiaryAction && /*#__PURE__*/ jsx("div", {
                                            className: tertiaryActionContainer({
                                                className: slots.tertiaryActionContainer
                                            }),
                                            children: renderTertiaryAction()
                                        }),
                                        hasSecondaryAction && /*#__PURE__*/ jsx("div", {
                                            className: secondaryActionContainer({
                                                className: slots.secondaryActionContainer
                                            }),
                                            children: renderSecondaryAction()
                                        }),
                                        /*#__PURE__*/ jsx("div", {
                                            className: primaryActionContainer({
                                                className: slots.primaryActionContainer
                                            }),
                                            children: renderPrimaryAction()
                                        })
                                    ]
                                }) : renderPrimaryAction()
                            })
                        ]
                    }),
                    helperText && /*#__PURE__*/ jsx(P, {
                        className: helperTextSlot({
                            className: slots.helperTextSlot
                        }),
                        palette: "neutral",
                        shade: "13",
                        children: helperText
                    })
                ]
            })
        ]
    });
}
export { StickyActionBar };
